'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SpinnerLoadWrapper = function SpinnerLoadWrapper(_ref) {
  var isLoading = _ref.isLoading,
      children = _ref.children,
      use = _ref.use,
      props = _objectWithoutProperties(_ref, ['isLoading', 'children', 'use']);

  if (isLoading) {
    return _react2.default.createElement(_UILoadingSpinner2.default, _extends({}, props, { grow: true, showLabel: true, use: use }));
  }

  return children;
};

SpinnerLoadWrapper.propTypes = {
  children: _react.PropTypes.node,
  isLoading: _react.PropTypes.bool
};

SpinnerLoadWrapper.defaultProps = {
  isLoading: false,
  use: 'link'
};

exports.default = SpinnerLoadWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/loading/SpinnerLoadWrapper.js
// module id = 334
// module chunks = 3 4